import { flow } from 'mobx';
import { types } from 'mobx-state-tree';
import { ApiRequest } from './ApiRequest';
import { portal_api_url } from '../config/portal-api-url';
import { YoUser } from '@yakoffice/yakoffice-firebase';

export const PortalApiGateway = types.model(
    'PortalApiGateway',
    {
        apiRequest: ApiRequest
    })
    .views(() => ({
        getUsersUrl(): string {
            return `${portal_api_url}/api/users`;
        },
        getUsersForProjectUrl(projectId: string): string {
            return `${portal_api_url}/api/${projectId}/users`;
        }
    }))
    .views(self => ({
        getUserUrl(userEmail: string): string {
            return `${self.getUsersUrl()}/${userEmail}`;
        },
        getUserForProjectUrl(projectId: string, userEmail: string): string {
            return `${self.getUsersForProjectUrl(projectId)}/${userEmail}`;
        }
    }))
    .actions(self => ({
        getUsers: flow(function* () {
            return yield self.apiRequest.get<YoUser[]>(self.getUsersUrl());
        }),
        getUser: flow(function* (userEmail: string) {
            return yield self.apiRequest.get<YoUser>(self.getUserUrl(userEmail));
        }),
        updateUser: flow(function* (user: YoUser) {
            return yield self.apiRequest.post(self.getUsersUrl(), user);
        }),
        deleteUser: flow(function* (userEmail: string) {
            return yield self.apiRequest.delete(self.getUserUrl(userEmail));
        })
    }))
    .actions(self => ({
        getUsersForProject: flow(function* (projectId: string) {
            return yield self.apiRequest.get<YoUser[]>(self.getUsersForProjectUrl(projectId));
        }),
        getUserForProject: flow(function* (projectId: string, userEmail: string) {
            return yield self.apiRequest.get<YoUser>(self.getUserForProjectUrl(projectId, userEmail));
        }),
        updateUserForProject: flow(function* (projectId: string, user: YoUser) {
            return yield self.apiRequest.post(self.getUsersForProjectUrl(projectId), user);
        })
    }));


// export interface IPortalApiGateway extends Instance<typeof PortalApiGateway> {
// }
